export default __webpack_public_path__ + "static/media/aspnetcore.134d9b26.svg";